import type { SortOptions } from '@tunasong/models'
import { defaultSortOptions as defSortOptions } from '@tunasong/models'
import type { EntityType } from '@tunasong/schemas'
import { useDeviceState } from '../util/device-state.hook.js'

/** Use device state for sort options and filter */
export const useSortFilterOptions = (
  optionsKey: string = 'default',
  {
    defaultFilter = [],
    defaultSortOptions = defSortOptions,
  }: { defaultFilter?: EntityType[]; defaultSortOptions?: SortOptions } | undefined = {}
) => {
  const [sortOptions = defaultSortOptions, setSortOptions] = useDeviceState<SortOptions>(
    `entities.${optionsKey}.sort`,
    defaultSortOptions
  )
  const [filter = [], setFilter] = useDeviceState<EntityType[]>(`entities.${optionsKey}.filter`, defaultFilter)

  return {
    sortOptions,
    setSortOptions,
    filter,
    setFilter,
  }
}

/**
 * Folder lists (a folder, a band's Library) list newest-created first (GH #3056). Sorted by updatedAt, files
 * reshuffled while a multi-file upload updated each of them. "Updated" stays in the sort menu, and a saved sort wins.
 */
export const folderSortOptions = { ...defSortOptions, sortBy: 'createdAt' } satisfies SortOptions

/** `useSortFilterOptions` for a folder list, with the folder default */
export const useFolderSortFilterOptions = (folderId?: string) =>
  useSortFilterOptions(folderId, { defaultSortOptions: folderSortOptions })
